export var Position = {
  AutoStart: 'auto-start',
  Auto: 'auto',
  AutoEnd: 'auto-end',
  TopStart: 'top-start',
  Top: 'top',
  TopEnd: 'top-end',
  BottomStart: 'bottom-start',
  Bottom: 'bottom',
  BottomEnd: 'bottom-end',
  LeftStart: 'left-start',
  Left: 'left',
  LeftEnd: 'left-end',
  RightStart: 'right-start',
  Right: 'right',
  RightEnd: 'right-end'
};